<template>
    <widget>
        <widget-header class="background-gradient-green-blue text-white tiny-forms">
            Status: {{ this.status }}<br>
            Last Pulled:{{ this.lastPulled }}<br>
            Last Message: {{ this.lastMessage ?? 'Ok' }}
        </widget-header>
    <widget-body>
          <VueCtkDateTimePicker
              v-model="reportedDate"
              :onlyDate="true"
              :format="'YYYY-MM-DD'"
              :formatted="'ll'"
              :label="'Reported Day'"
              locale="en"
              :range="false"
              :inititale-value="startDate"
               class="mb-2"
              :onchange="getHistory()"
          ></VueCtkDateTimePicker>
    
          <YInput
              label="Click Id"
              v-model="clickId"
              :onchange="getHistory()"
          /><br>
          <y-button
              class="btn btn-blue"
              :is-loading="isSubmitting"
              @click="runRevenuePull"
              @keydown.enter="runRevenuePull"
          >
            Pull Revenue
      </y-button ><br>
    
        <br>
        <YTable
          v-if="postedClickHistory"
          :data="postedClickHistory || []"
          :bottom-loading="this.isSubmitting == true"
        >
        <template slot="header-row">
            <th>Click Id</th>
            <th>Value</th>
            <th>Reported Date</th>
            <th>Posted At</th>
        </template>
        <template slot="row" slot-scope="props">
            <td>{{ props.rowData.clickId }}</td>
            <td>{{ props.rowData.value }}</td>
            <td>{{ props.rowData.reportedDate }}</td>
            <td>{{ props.rowData.createdAt }}</td>
        </template>
        </YTable>

    </widget-body>
    </widget>
</template>
<script>
import gql from 'graphql-tag'
import ValidationErrorsMixin from '@/mixins/ValidationErrorsMixin'
export default {
    mixins: [ValidationErrorsMixin],
    props: {
        helperId: {
            type: Number,
            required: true
        },
        lastPulled: {
            type: String,
            required: false
        },
        status: {
            type: String,
            required: false
        },
        lastMessage: {
            type: String,
            required: false
        },
    },
    /*apollo: {
        $subscribe: {
            offersOptimized: {
            query: gql`
                subscription RunAdvertiserRevshareHelperSubscription {
                    runAdvertiserRevshareHelperSubscription
                }
            `,
            variables() {
                return {}
            },
            result() {
                this.getHistory()
            }
            }
        }        
    },*/
    components: {},
    data() {
      return {
        postedClickHistory: null,
        isSubmitting: true,
        clickId:null,
        reportedDate: this.$dateTime.local().minus({ days: 1 }).toFormat('yyyy-LL-dd'),
        startDate: this.$dateTime.local().minus({ days: 1 }).toFormat('yyyy-LL-dd'),
      }
    },
     watch: {},
    computed: {},
    close() {
      this.$emit('close')
    },
    mounted() {
      this.getHistory()
    },
    updated() {},
    methods: {
      getHistory() {
        this.$apollo
          .query({
            query: gql`
              query  AdvertiserAccountRevshareHelperClick($filters: RevhsareHelperPostedClickFilter!) {
                advertiserAccountRevshareHelperClick(filters: $filters) {
                  id
                  advertiserAccountRevshareHelperId
                  value
                  clickId
                  reportedDate
                  createdAt
                }
              }
            `,
            variables: {
                filters: {
                    advertiserAccountRevshareHelperId: { value: [this.helperId] },
                    reportedDate: {value:[this.reportedDate]},
                    clickId: this.clickId ? {value:[this.clickId]} : undefined
                }
            }
          })
          .then(({ data }) => {
            this.postedClickHistory = data.advertiserAccountRevshareHelperClick
            this.isSubmitting = false
          })
          .catch(error => {
            this.setValidationErrors(error)
            this.isSubmitting = true
          })
      },
      runRevenuePull() {
        console.log('herePull')
        this.isSubmitting = true
        this.$apollo
          .mutate({
            mutation: gql`
              mutation runAdvertiserRevshareHelperJob($input: RunAdvertiserRevshareHelperJobInput!) {
                runAdvertiserRevshareHelperJob(input: $input) {
                  status
                  errors
                }
              }
            `,
            variables: {
              input: {
                    helperId: this.helperId,
                    reportedDate: this.reportedDate
                }
            }
          })
          .then(() => {
            console.log('fail')
            this.isSubmitting = false
            this.$toastr.s('', 'Helper Queued for next run (start of next hour with reported date '+this.reportedDate+')')
          })
          .catch(() => {})
      }
    }
}
</script>
 <style scoped>
  .x-form > *:not(:last-child) {
    @apply mb-2;
  }
</style>